/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import { Input, InputGroup, InputGroupText } from 'reactstrap';
import { formatCalculationNumber } from '../../../../../../utils/formula';
import { ColumnInputProps } from '../InputInterface';

export default function CalculatedInput(props: ColumnInputProps) {
  const {
    column,
    inputColumn,
    placeholder,
    label
  } = props;

  const value = formatCalculationNumber(inputColumn.value ?? '');
  const { required, max, min } = column.validation ?? {};

  const floatVal = parseFloat(value.replace(/,/g, ''));
  const isLessThanMax = max === undefined || floatVal <= max;
  const isMoreThanMin = min === undefined || floatVal >= min;
  const isValid = value === '' || (isLessThanMax && isMoreThanMin);

  return <div className='mb-3 auto-calculation'>
    {label}
    <InputGroup>
      {!isValid ? (
        <InputGroupText className='styled-readonly is-invalid'>
          <i className='fa fa-exclamation-triangle text-ThemeDangerMedium' />
        </InputGroupText>
      )
        : null}
      <Input
        autoComplete='off'
        type='text'
        max={max}
        min={min}
        invalid={!isValid}
        className='styled-readonly'
        id={column.code}
        name={column.code}
        value={value}
        placeholder={placeholder}
        disabled={true}
        required={required !== false}
      />
    </InputGroup>
  </div>
}
